'use client';

import { useState } from 'react';
import ContactModal from './ContactModal';

interface PlanContactButtonProps {
  isPopular?: boolean;
}

export default function PlanContactButton({ isPopular = false }: PlanContactButtonProps) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const buttonClass = `block w-full py-3 px-6 font-bold text-center transition ${
    isPopular
      ? 'bg-brand-black text-white hover:bg-opacity-90'
      : 'bg-brand-red text-white hover:bg-opacity-90'
  }`;

  return (
    <>
      {/* Mobile: Click to Call */}
      <a
        href="tel:17187488888"
        className={`lg:hidden ${buttonClass}`}
      >
        GET STARTED
      </a>

      {/* Desktop/Tablet: Contact Us button */}
      <button
        onClick={() => setIsModalOpen(true)}
        className={`hidden lg:block ${buttonClass}`}
      >
        GET STARTED
      </button>

      <ContactModal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)} 
      />
    </>
  );
}
